export default {
  filters: {
    today: 'Vandaag',
    yesterday: 'Gisteren',
    this_week: 'Deze week',
    last_week: 'Vorige week',
    this_month: 'Deze maand',
    last_month: 'Vorige maand',
    all: 'Alles',
  },
};
